/* eslint-disable @typescript-eslint/no-unused-vars */
import GenericButton from "@ui-components/Button/GenericButton"
import React, { useState }  from "react"
import { ReactComponent as LeftIcon } from "../../../../../assets/Icons/IconLeft.svg";
import { useNavigate } from "react-router-dom";
import GenericAlert from "@ui-components/Alert/GenericAlert";
import { useSelector } from "react-redux";
import { RootState } from "@redux/store/store";

export default function CloudDetailsTabs() {
      const navigate = useNavigate();
      const lag = useSelector((state: RootState) => state.port.lag);

      const alertConfigs: Record<
        string,
        { title: string; description: string; confirmLabel: string; variant?: "confirm" | "success" | "error" | "warning" }
        > = {
        "Break LAG": {
          title: "Break LAG",
          description: "Are you sure you want to break the LAG? This might cause connection issues.",
          confirmLabel: "Yes, break it",
          variant: "warning",
        },
        "Add LAG": {
          title: "Add LAG",
          description: "No LAG is set up yet. Are you sure you want to add a new LAG configuration?",
          confirmLabel: "Yes, add it",
          variant: "confirm",
        },
        "Disable Port": {
          title: "Disable Port",
          description: "Are you sure you want to disable this port? This action is irreversible.",
          confirmLabel: "Yes, disable it",
          variant: "warning",
        },
        "Delete Port": {
          title: "Delete Port",
          description: "Are you sure you want to delete this port? All associated data will be lost.",
          confirmLabel: "Yes, delete it",
          variant: "error",
        },
      };

      const [alertState, setAlertState] = useState<{ isOpen: boolean; selection: string }>({
        isOpen: false,
        selection: "",
      });

        // Centralized handler for the alert's confirm action (pending this endpoints)
        const handleAlertConfirm = () => {
          switch (alertState.selection) {
            case "Break LAG":
              // dispatch(breakLagAction());
              break;
            case "Add LAG":
              // dispatch(addLagAction());
              break;
            case "Disable Port":
              // dispatch(disablePortAction());
              break;
            case "Delete Port":
              // dispatch(deletePortAction());
              break;
            default:
              console.warn("Unhandled alert action:", alertState.selection);
          }
          setAlertState({ isOpen: false, selection: "" });
        };

    return (
        <div
            className="
                flex
                justify-end
                w-full
                mt-1
            "
        >
            <div className="flex w-full justify-between">
                <GenericButton
                    variant="secondary"
                    shape="ghost"
                    size="sm"
                    icon={<LeftIcon className="h-5 w-5 text-semantic-text-secondary" />}
                    onClick={() => { navigate("/kontrol/cloud-connectivity")}}
                />
            </div>
            {alertState.isOpen && (
              <GenericAlert
                isOpen={alertState.isOpen}
                onClose={() => setAlertState({ isOpen: false, selection: "" })}
                onConfirm={handleAlertConfirm}
                title={alertConfigs[alertState.selection]?.title || "Warning"}
                description={alertConfigs[alertState.selection]?.description || ""}
                confirmLabel={alertConfigs[alertState.selection]?.confirmLabel || "Confirm"}
                cancelLabel="Cancel"
                variant={alertConfigs[alertState.selection]?.variant || "warning"}
              />
            )}
        </div>
    )
}
